
import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Link as ScrollLink, scroller } from 'react-scroll';
import './navbar.css';
import Logo from '../../Assets/logo1.png';

function Navbar() {

  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    
  };

  const handleScrollToSection = (section) => {
    if (location.pathname !== '/') {
      // Navigate to the homepage first
      navigate('/');
      setTimeout(() => {
        // Scroll to the section after navigation
        scroller.scrollTo(section, { smooth: true, duration: 500 });
      }, 100); // Delay to ensure the homepage loads
    } else {
      // Directly scroll if already on the homepage
      scroller.scrollTo(section, { smooth: true, duration: 500 });
    }
  };

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <>
    
    <nav className="navbar">
      <div className="navbar-logo" onClick={refreshPage}>
        <img src={Logo} alt="ShriTech" className="logo-image" />
      </div>


      <div className="menu-toggle" onClick={toggleMenu}>
        ☰
      </div>
      <ul className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
        <li><Link className="navbar-link" to="/">Home</Link></li>
        <li><Link className="navbar-link" to="/about">About Us</Link></li>

        <li>
          <span
            className="navbar-link"
            onClick={() => handleScrollToSection('staffing')}
          >
            Services
          </span>
        </li>
        <li>
          <span
            className="navbar-link"
            onClick={() => handleScrollToSection('job-browsing-section')}
          >
            Job Openings
          </span>
        </li>


        <li><Link className="navbar-link" to="/clients">Clients</Link></li>
        <li><Link className="navbar-link" to="/careers">Careers</Link></li>
        <li><Link className="navbar-link" to="/contact">Contact Us</Link></li>
      </ul>
      


    </nav>
    </>
    
  );
}

export default Navbar;
